function Connection() {
    this.Node1 = []; // identifier
    this.Node2 = []; // identifier
    this.Reasons = [];
}
if (typeof exports !== 'undefined') {
    module.exports = Connection;
}